export default __webpack_public_path__ + "static/media/upArrow.5c4643a0.svg";